// extracted by mini-css-extract-plugin
module.exports = {"formatDate":"StartPickTrip_formatDate__-BFNG"};